import { normalizeSupergraphMeetingNode } from './utils'

export const transformGetMeetingSupergraphResponse = (response: any) => {
  const node = response?.listMeetings?.meetings?.[0]?.node
      ?? response?.meetingsPageList?.meetings?.[0]?.node
      ?? response?.listMeetings?.edges?.[0]?.node
      ?? response?.meetings?.edges?.[0]?.node
      ?? null

  return node ? normalizeSupergraphMeetingNode(node) : null
}
